"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _stat = _interopRequireWildcard(require("@/api/stat"));

var _statItem = _interopRequireDefault(require("@/api/statItem"));

var _otwooChannel = _interopRequireWildcard(require("@/api/otwooChannel"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'otwoo0201',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    DateRangePicker: _DateRangePicker.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.crud)()],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '0201统计',
      url: 'api/otwooStat/otwoo0201',
      sort: '',
      crudMethod: _objectSpread({}, _stat.default)
    });
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      rowData: {},
      statTime: [],
      form1: [],
      permission: {},
      domain: '',
      selectDepts: [],
      dynamicValidateForm: {
        domains: [],
        isShow: false
      },
      tempSelectionKeys: [],
      rules: {},
      sourceCites: [],
      cities: [],
      listItems: [],
      rightItem: [],
      queryTypeOptions: [{
        key: 'createTime',
        display_name: '统计起始时间'
      }]
    };
  },
  created: function created() {
    this.statTime.push(this.getFirstDay());
    this.statTime.push(this.getLastDay());
    this.crud.query.createTime = [];
    this.crud.query.createTime.push(this.getFirstDay());
    this.crud.query.createTime.push(this.getLastDay());
    this.crud.optShow = {
      add: false,
      edit: false,
      del: false,
      download: true,
      reset: true
    };
  },
  methods: {
    onDrawer: function onDrawer(scope, _mark) {
      var _this = this;

      this.form1 = [];
      this.rowData = scope.row;
      var param = {
        "msgFrom": scope.row.msgFrom,
        "deptName": scope.row.dept_name,
        "userName": scope.row.nick_name,
        "mark": _mark,
        "createTime": this.crud.query.createTime
      };

      _otwooChannel.default.otwoo0103Detail(param).then(function (res) {
        _this.form1 = res.content;
      });
    },
    handleClose: function handleClose(done) {
      done();
    },
    doSearch: function doSearch() {
      console.log('this.statTime');
      console.log(this.statTime);
      this.crud.query.createTime = this.statTime;
      this.crud.toQuery();
    },
    removeDomain: function removeDomain(item) {
      console.log(item);
      this.query[item.prop] = undefined;
      this.queryType[item.prop] = undefined;
      var index = this.dynamicValidateForm.domains.indexOf(item);

      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain: function addDomain() {
      this.dynamicValidateForm.isShow = true;
      this.dynamicValidateForm.domains.push({
        key: Date.now()
      });
    },
    getFirstDay: function getFirstDay() {
      //当前月第一天
      var y = new Date().getFullYear(); //获取年份

      var m = new Date().getMonth() + 1; //获取月份

      var d = '01';
      m = m < 10 ? '0' + m : m; //月份补 0

      return [y, m, d].join("-") + " 00:00:00";
    },
    getLastDay: function getLastDay() {
      //当前月最后一天
      var y = new Date().getFullYear(); //获取年份

      var m = new Date().getMonth() + 1; //获取月份

      var d = new Date(y, m, 0).getDate(); //获取当月最后一日

      m = m < 10 ? '0' + m : m; //月份补 0

      d = d < 10 ? '0' + d : d; //日数补 0

      return [y, m, d].join("-") + " 23:59:59";
    }
  }
};
exports.default = _default;